import { FunctionComponent } from "react"
import ResourcesSecondarySidebarWidget from "../secondary-sidebar/resources.secondary-sidebar.widgets"

const SecondarySidebarWidget: FunctionComponent = () => {
  return <div className="flex flex-1 flex-col border-r border-r-neutral-200">
    <ResourcesSecondarySidebarWidget />
  </div>
}

export default SecondarySidebarWidget